/*
var offerEndDate = new Date("2025-01-31T23:59:59").getTime();

        var timerInterval = setInterval(function() {
            var now = new Date().getTime();

            var distance = offerEndDate - now;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            $("#bb-days").text(days);
            $("#bb-hrs").text(hours);
            $("#bb-mins").text(minutes);
            $("#bb-secs").text(seconds);

            if (distance < 0) {
                clearInterval(timerInterval);
                //$("#offer-timer").text("Annual Medicare Enrollment has ended");
            }
        }, 1000);

*/

    function Timer(duration, display) {

        var timer = duration,
            hours, minutes, seconds;
        var interval = setInterval(function() {
            // console.log(timer);
            hours = parseInt((timer / 3600) % 24, 10)
            minutes = parseInt((timer / 60) % 60, 10)
            seconds = parseInt(timer % 60, 10);

            hours = hours < 10 ? "0" + hours : hours;
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            $("#bb-hrs").text(hours);
            $("#bb-mins").text(minutes);
            $("#bb-secs").text(seconds);

            --timer;

            if (timer == -1) {
                clearInterval(interval);
            }
        }, 1000);
    }

$(document).ready((function(){$(".bb-close-button").on("click",(function(){console.log("click"),$(".bottom-float-bar").fadeOut("slow")}));var twentyFourHours = 24 * 60 * 60;
        Timer(twentyFourHours);setTimeout((function(){$(".bottom-float-bar").fadeIn("slow")}),1500)}));